module.exports = __webpack_public_path__ + "static/becon+-fd7601ddd7d55826fd8fc25c421b928e.png";